import axios from 'axios'; /* TODO: Setup and use Axios API instance */
import { endpoint, API_BASE_URL, TENANT_API_ENDPOINTS } from '@/utils/endpoints';
import { Tenant } from '@/models/tenant.model';

export default {
	namespaced: true,

	state: {
		tenant: new Tenant(),
	},

	getters: {
		tenant: state => state.tenant,
	},

	mutations: {
		SET_TENANT: (state, data) => (state.tenant = data),
	},

	actions: {
		async LoadTenant({ commit }, id) {
			if (!id) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });

			try {
				const url = endpoint(API_BASE_URL, TENANT_API_ENDPOINTS.TENANT, {
					params: {
						id,
					},
				});

				const results = await axios.get(url);
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load tenant' });

				commit('SET_TENANT', new Tenant(results.data.data));

				return new Tenant(results.data.data);
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},
	},
};
